import { moleculeHeadingFields } from 'molecules/Heading/config';
import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

import type { Component, Input } from '@builder.io/sdk';

const speakersFields = [
  {
    name: 'heading',
    type: 'object',
    subFields: moleculeHeadingFields,
    helperText: 'Heading section for this block. Includes eyebrow, main heading, body, and optional buttons.',
  },
  {
    name: 'columns',
    type: 'string',
    enum: ['two', 'three'],
    defaultValue: 'three',
    helperText: 'Number of speaker columns on desktop. "two" suits event pages with fewer speakers.',
  },
  ...sectionFields,
  {
    name: 'speakers',
    type: 'list',
    helperText: 'Add one or more speakers to display in this section.',
    subFields: [
      imageField('photo'),
      {
        name: 'name',
        type: 'string',
        required: true,
        helperText: 'Full name of the speaker (required).',
      },
      {
        name: 'title',
        type: 'string',
        helperText: 'Professional title or role of the speaker (optional).',
      },
      {
        name: 'linkedinUrl',
        type: 'url',
        helperText: 'Link to the speaker’s LinkedIn profile (optional).',
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

export const meetTheSpeakersConfig = {
  name: 'meet-the-speakers',
  inputs: speakersFields,
} satisfies Component;

export type MeetTheSpeakersProps = GenerateBuilder<typeof speakersFields>;
